import React, { useState } from 'react';
import styles from './SelectModalOption.module.css';
import useTheme from 'config/useTheme';

const SelectModalOption = ({ placeholder, setOption, optionList }) => {
    const { dark } = useTheme();
    const [opened, setOpened] = useState(false);
    return (
        <div className={` ${dark ? styles.dark : ""} ${styles.select_option}`}>
            <button type='button' onClick={() => setOpened(true)}>{placeholder}</button>
            {opened && <div className={styles.select_option_options}>
                {optionList.map((option) => (
                    <button
                        type='button'
                        key={option}
                        onClick={() => { setOpened(false); setOption(option) }}
                    >
                        {option}
                    </button>
                ))}
            </div>}
        </div>
    );
}

export default SelectModalOption;